import React, { useEffect, useState, useCallback } from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AllOrders from "./AllOrders";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const TabelaLojistas = () => {
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(true); 

  const fecthLojistas = useCallback(
    async () => {
      setLoading(true);
      
      const response = await apiClient.get(`/lojista/`);
      
      if (response.sucesso) {
        setLoading(false);
        return response.dados;
      } else {
        setLoading(false);
        toast.error(response.mensagem);
        console.log(response);
        return [];
      }
    },
    [] 
  );

  useEffect(() => {
    if (shouldFetch) {
      const fetchData = async () => {
        const retorno = await fecthLojistas();
        setOrderList(retorno);
        setShouldFetch(false);
      };

      fetchData();
    }
  }, [shouldFetch, fecthLojistas]);

  document.title = "Lojistas | Painel Fort Exchange";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Lista de Lojistas"
            pageTitle="Aplicações"
          />
          <Row>
            <AllOrders
              orderList={orderList}
              loading={loading}
              setShouldFetch={setShouldFetch}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TabelaLojistas;
